module.exports = __webpack_public_path__ + "static/media/44379405_2199904253418087_7542876996083122176_o.7d8a8d18.jpg";